export function ContactPage() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-bold text-white mb-6">Contact</h1>
      <p className="text-slate-400 mb-8">
        Have a question, feedback, or need help? Reach out to us.
      </p>
      <div className="card space-y-4">
        <div>
          <h2 className="text-lg font-semibold text-white mb-1">Email</h2>
          <a href="mailto:hello@bookmyband.io" className="text-indigo-400 hover:text-indigo-300 transition-colors">
            hello@bookmyband.io
          </a>
        </div>
        <div>
          <h2 className="text-lg font-semibold text-white mb-1">Response time</h2>
          <p className="text-slate-400">We typically respond within 1–2 business days.</p>
        </div>
      </div>
    </div>
  );
}
